(function () {
  document.querySelectorAll('.image-pop-cta').forEach(function (root) {
    const pool = root.querySelector('.image-pop-cta__pool')
    if (!pool) return

    const srcs = []
    pool.querySelectorAll('img[data-src]').forEach(function (img) {
      srcs.push(img.getAttribute('data-src'))
    })
    if (!srcs.length) return

    let incr = 0,
      oldVal = 0,
      firstMove = true,
      indexImg = 0,
      resetDist = window.innerWidth / 15

    root.addEventListener('mousemove', function (e) {
      const val = e.clientX

      if (firstMove) {
        firstMove = false
        oldVal = val
        return
      }

      incr += Math.abs(val - oldVal)
      oldVal = val

      if (incr > resetDist) {
        incr = 0
        const rect = root.getBoundingClientRect()
        createPop(e.clientX - rect.left, e.clientY - rect.top)
      }
    })

    function createPop(x, y) {
      const img = document.createElement('img')
      img.className = 'image-pop-cta__pop'
      img.src = srcs[indexImg]
      img.alt = ''
      root.appendChild(img)

      const tl = gsap.timeline({
        onComplete: function () {
          if (root.contains(img)) root.removeChild(img)
          tl && tl.kill()
        }
      })

      tl.fromTo(
        img,
        {
          x: x,
          y: y,
          xPercent: -50 + (Math.random() - 0.5) * 80,
          yPercent: -50 + (Math.random() - 0.5) * 10,
          rotation: (Math.random() - 0.5) * 20,
          scaleX: 1.3,
          scaleY: 1.3
        },
        {
          scaleX: 1,
          scaleY: 1,
          ease: 'elastic.out(2, 0.6)',
          duration: 0.6
        }
      ).to(img, {
        scale: 0.5,
        duration: 0.3,
        delay: 0.1,
        ease: 'back.in(1.5)'
      })

      indexImg = (indexImg + 1) % srcs.length
    }
  })
})()
